import { AxiosResponse } from 'axios';
import agent from 'src/api_v2/base';
import { FetchProfileAuditListParams, ProfileAuditListPageResult } from './types';
import moment from 'moment';
class ProfileAuditApi {
  async fetchProfileAuditList(params: FetchProfileAuditListParams) {
    try {
      const response: AxiosResponse = await agent.get(
        `/profile-audit?${params.toString()}`
      );

      if (response.status === 200) {
        return response.data as ProfileAuditListPageResult;
      }

      return []
    } catch (err) {
      throw new Error(err);
    }
  }

  async exportFile(params: FetchProfileAuditListParams): Promise<any> {
    try {
      const response: AxiosResponse = await agent.post(
        `/profile-audit/export/csv?${params.toString()}`,
        {
          responseType: 'blob'
        }
      );

      if (response.status === 201) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.setAttribute(
          'download',
          `profile-${moment().format('YYYY-MM-DD, HH-mm')}.csv`
        );
        link.href = url;
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        window.URL.revokeObjectURL(url);

        return true;
      }
      return false;
    } catch (err) {
      throw err;
    }
  }

}

const profileAuditListApi = new ProfileAuditApi();
export default profileAuditListApi;
